import { action, computed, observable } from "mobx";
import http, { getQuery } from "../service/http";
import qs from "qs";
import memberStore from "./member";

const cache = {};

const weburl =
  process.env.REACT_APP_MODE === "PRODUTION"
    ? "https://book.diningcity.asia"
    : "https://staging-book.diningcity.asia";

class Store {
  @observable restaurant = {};
  @observable weburl = "";
  @observable restaurantId = "";
  @observable urls = {};
  @observable currency = "";
  url = process.env.REACT_APP_MODE === "PRODUTION"
    ? "https://api.diningcity.asia/public"
    : "https://staging-api.diningcity.asia/public";
  lang = getQuery().lang;

  /**获取webform地址 */
  @computed
  get webform() {
    const { id } = this.restaurant;
    if (!id) return "";
    const { lang } = getQuery();
    const path = `${weburl}/#/restaurants/${id}/reservation?`;
    const private_token = memberStore.private_token;
    const query = qs.stringify({
      lang,
      private_token,
    });
    return path + query;
  }

  /**
   *隐私条款
   *
   * @readonly
   * @memberof Store
   */
  @computed
  get privacyUrl() {
    try {
      let restaurant = this.restaurant;
      return restaurant.privacy_policy_url;
    } catch (error) {
      return "javascript:void(0);";
    }
  }

  @action
  setUrl(restaurantId) {
    const { project } = getQuery();
    const common = `${this.url}/restaurants/${restaurantId}`;
    this.urls = {
      project: `${this.url}/project_configs/${project}`,
      chef: `${common}/chef`,
      details: `${common}`,
      meals: `${common}/extras_events/${project}/meals`,
      reviews: `${this.url}/reviews`,
      pictures: `${common}/pictures`,
      replies: `${this.url}/replies`,
      events: `https://eventsapi.diningcity.asia/api/v1/events/${project}`,
      capacity: `${this.url}/extras_events/${project}/restaurants/${restaurantId}/capacity`,
    };
  }

  /**获取预订文案 */
  @action
  async getCapacity() {
    try {
      let { data } = await http.get(`${this.urls.capacity}`, {
        params: {
          "api-key": "cgecegcegcc",
          lang: this.lang,
        },
      });
      return data;
    } catch (error) {
      return null;
    }
  }

  /**获取餐厅信息 */
  @action
  async getRestaurantDetails() {
    try {
      let { data } = await http.get(`${this.urls.details}`, {
        params: {
          "api-key": "cgecegcegcc",
          lang: this.lang,
        },
      });
      this.restaurant = data;
      this.restaurantId = data.id;
      try {
        this.currency = data.region.currency;
      } catch (error) { }
      return data;
    } catch (error) {
      return {};
    }
  }

  /**获取厨师信息 */
  @action
  async getChef() {
    try {
      let projectConfig = await http.get(this.urls.project)
      if (!projectConfig.data.is_need_show_chef) return null
      let { data } = await http.get(`${this.urls.chef}`, {
        params: {
          "api-key": "cgecegcegcc",
          lang: this.lang,
        },
      });
      return data;
    } catch (error) {
      return null;
    }
  }

  /**获取图片信息 */
  @action
  async getPictures() {
    try {
      let { data } = await http.get(`${this.urls.pictures}`, {
        params: {
          "api-key": "cgecegcegcc",
          lang: this.lang,
          per_page: 999
        },
      });
      return data;
    } catch (error) {
      return [];
    }
  }

  /**获取菜单 */
  @action
  async getMenus() {
    const { project } = getQuery();
    const mealsUrl = `/public/extras_events/${project}/restaurants/${this.restaurantId}/meals`;
    try {
      let { data } = await http.get(mealsUrl, {
        params: {
          "api-key": "cgecegcegcc",
          platform: "web",
          include_extras_menu: true,
          lang: this.lang,
        },
      });
      return data;
    } catch (error) {
      return [];
    }
  }

  /**获取菜单配图 */
  @action
  async getMenuPhotos(id) {
    const cacheKey = `getMenuPhotos_${id}`;
    if (cache[cacheKey]) return cache[cacheKey];
    const url = `${this.url}/photos`;
    try {
      let { data } = await http.get(url, {
        params: {
          id,
          type: "course",
          lang: this.lang, 
          per_page: 9999,
        },
        headers: {
          "accept-version": 2,
        },
      });
      cache[cacheKey] = (data || []).map((item) => {
        return {
          ...item,
          picture_url: item.image_url,
        };
      });
      return cache[cacheKey];
    } catch (error) {
      return [];
    }
  }

  /**获取评论回复 */
  @action
  async getReplies(reviewId, page = 1) {
    try {
      let { data, headers } = await http.get(this.urls.replies, {
        params: {
          platform: "desktop",
          review_id: reviewId,
          page,
          per_page: 200,
        },
        headers: {
          "accept-version": "2",
        },
      });
      data.headers = headers;
      return data;
    } catch (error) {
      return [];
    }
  }

  /**获取评论 */
  @action
  async getReviews(page = 1, course_id, per_page = 20) {
    try {
      let { data, headers } = await http.get(this.urls.reviews, {
        params: {
          source_type: "restaurant",
          source_id: this.restaurantId,
          course_id: course_id || undefined,
          page,
          per_page: per_page,
        },
        headers: {
          "accept-version": "2",
        },
      });
      data.headers = headers;
      return data;
    } catch (error) {
      return [];
    }
  }

  /**获取合作伙伴 */
  @action
  async getPartners(city) {
    const { project } = getQuery();
    const url = `https://eventsapi.diningcity.asia/api/v1/cities/${city}/sponsor_categories`;
    try {
      let { data, headers } = await http.get(url, {
        params: {
          lang: this.lang,
          project: project,
        },
        headers: {
          Authorization:
            "Basic ZGluaW5nY2l0eV9iYWNrZW5kOjQzNzdkNDQ5NjA4ZDRlZGJiZmY2MzRlMjM2NzBiNDlh",
        },
      });
      return data;
    } catch (error) {
      return [];
    }
  }

  /**设置高度 */
  @action
  setHeight() {
    const isMobile = getPlatform();
    try {
      window.top.postMessage(
        {
          type: "finish",
          data: {
            height: '100vh'
            // isMobile ? "100vh" : document.body.scrollHeight + "px",
          },
        },
        "*"
      );
    } catch (error) { }
  }
  /** 提交评论回复 */
  @action
  async saveReply(review_id, content) {
    let { data } = await http.post(
      `/public/replies`,
      {
        review_id,
        content
      },
      {
        headers: {
          'accept-version': '2',
        },
      }
    )
    return data
  }
}

function getPlatform() {
  var userAgent = navigator.userAgent;
  var platform = {
    trident: userAgent.indexOf("Trident") > -1,
    presto: userAgent.indexOf("Presto") > -1,
    webKit: userAgent.indexOf("AppleWebKit") > -1,
    gecko: userAgent.indexOf("Gecko") > -1 && userAgent.indexOf("KHTML") == -1,
    mobile: !!userAgent.match(/AppleWebKit.*Mobile.*/),
    android:
      userAgent.indexOf("Android") > -1 || userAgent.indexOf("Linux") > -1, //android终端或者uc浏览器
    iPhone: userAgent.indexOf("iPhone") > -1, //是否为iPhone或者QQHD浏览器
    iPad: userAgent.indexOf("iPad") > -1, //是否iPad
    webApp: userAgent.indexOf("Safari") == -1, //是否web应该程序，没有头部与底部
  };
  var isMobile =
    platform.mobile || platform.android || platform.iPhone || platform.iPad;

  return isMobile;
}

export default new Store();
